import React from "react"

const HoldIcon = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <path
        d="M0.152 1.234C4.32134e-07 1.602 0 2.068 0 3V13C0 13.932 4.32134e-07 14.398 0.152 14.766C0.355419 15.2551 0.744545 15.6435 1.234 15.846C1.602 16 2.068 16 3 16C3.932 16 4.398 16 4.766 15.848C5.25508 15.6446 5.64349 15.2555 5.846 14.766C6 14.398 6 13.932 6 13V3C6 2.068 6 1.602 5.848 1.234C5.64458 0.744921 5.25545 0.356513 4.766 0.153999C4.398 -6.70552e-07 3.932 0 3 0C2.068 0 1.602 4.32134e-07 1.234 0.152C0.744921 0.355419 0.354514 0.744545 0.152 1.234ZM10.152 1.234C10 1.602 10 2.068 10 3V13C10 13.932 10 14.398 10.152 14.766C10.3554 15.2551 10.7445 15.6435 11.234 15.846C11.602 16 12.068 16 13 16C13.932 16 14.398 16 14.766 15.848C15.2551 15.6446 15.6435 15.2555 15.846 14.766C16 14.398 16 13.932 16 13V3C16 2.068 16 1.602 15.848 1.234C15.6446 0.744921 15.2555 0.356513 14.766 0.153999C14.398 -6.70552e-07 13.932 0 13 0C12.068 0 11.602 4.32134e-07 11.234 0.152C10.7449 0.355419 10.3545 0.744545 10.152 1.234Z"
        fill={color}
      />
    </svg>
  )
}

export default HoldIcon
